<div  *ngIf="isOpen">
   
    <mat-card class="notification-panel box-shadow">
      <mat-card-header>
        <mat-card-title>
          <h3>Notifications</h3>
        </mat-card-title>
      </mat-card-header>
      
   
      <mat-tab-group (selectedTabChange)="switchTab($event)">
        <mat-tab label="user">
          <ng-template mat-tab-label>
            <mat-icon style="color: rgb(230, 235, 241);">person</mat-icon>
          </ng-template>
    
          <div class="marquee">
            <span *ngIf="userMessage.length===0">
              No new notifications.
            </span>
            <div *ngFor="let message of userMessage; let i = index">
              <div class="message">
                
               
                <span class="message-number">{{ i + 1 }}.</span>
                <span class="message-content">{{message.requesting_org.name}} Organization has {{ message.requestStatus }} your request.</span>
              </div>
            </div>
          </div>
        </mat-tab>
        
        <mat-tab *ngIf="isLoggedIn() && hasRole('OrganizationAdmin')" label="org">
          <ng-template mat-tab-label>
            <mat-icon style="color: rgb(230, 235, 241);">business</mat-icon>
          </ng-template>
          
          <div class="marquee">
            <span *ngIf="orgMessage.length===0" >
              No new notifications.
            </span>
            <div *ngFor="let message of orgMessage; let i = index">
              <div class="message">
                <span class="message-number">{{ i + 1 }}.</span>
                <span class="message-content">User:{{ message.request_send_to_user.username }} has {{ message.requestStatus }} your request for  {{ message.requesting_org.name }} Organization.</span>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card>
  </div>
  

